export default {
  default: () => import("/home/denis/sources/sos-amiante/client/layouts/default.vue")
}